var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.72 20.04 14.06 1.33A2.23 2.23 0 0 0 12.01 0a2.25 2.25 0 0 0-2.05 1.33L.31 20.04a2.99 2.99 0 0 0 0 2.64 2.4 2.4 0 0 0 2 1.32h19.3a2.42 2.42 0 0 0 2.06-1.32 2.99 2.99 0 0 0 .05-2.64Zm-11.76.74a1.57 1.57 0 0 1-1.46-.94 1.55 1.55 0 0 1 1.11-2.14 1.58 1.58 0 0 1 1.62.64 1.55 1.55 0 0 1-1.27 2.44Zm0-4.8a1.58 1.58 0 0 1-1.43-.98c-.08-.19-.11-.4-.11-.6V8a.72.72 0 0 1 .43-.73c.1-.05.2-.07.3-.07h1.63a.73.73 0 0 1 .68.47c.03.09.05.18.05.28v6.45a1.56 1.56 0 0 1-1.55 1.56V16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.711a0606d2af90fb96502609db96ef3c.svg";
export { ForwardRef as ReactComponent };